<template>
    <div>

        <section class="feature-section mb-30">
            <div class="container">
                <h2><i class="p1 fa fa-plug"></i> Simple but Powerful Data Integrations</h2>
                <p class="mb-40 text-left">
                    Simple to use plugins for data integration between Databases, SaaS Applications, Cloud Storage, API's and Streaming Services.
                    <br />
                    Skippr is agnostic of your data source and destination, automatically detecting schema on load so you can connect any data source to any destination.
                </p>

                <div class="row mb-30">
                    <div v-for="(model, index) in plugins" v-bind:key="index"  class="col-xs-4 col-md-2">
                        <div class="contact-box" v-on:click="clickEvent(model)">
                            <div class="row">
                                <div class="col-4 mb-30">
                                    <div class="text-center">

                                        <img v-bind:src="'images/plugins/data_source/' + model.name + '/logo.png'"
                                             class="img-circle m-t-xs img-fluid"
                                             max-width="100px"
                                             max-height="100px"
                                             style="
                                                max-width: 100px;
                                                max-height: 100px;
                                                padding: 12px;
                                                vertical-align: middle;
                                                background-color: #fff;
                                                box-shadow: 0 6px 20px -5px rgba(50,50,93,0.25);
                                                cursor: pointer;"
                                        />
                                        <div class="m-t-xs font-bold">{{ model.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

<!--                <p class="text-center">-->
<!--                    <router-link to="/integrations/sources" class="btn btn-primary btn-sm">View Data Sources</router-link>-->
<!--                </p>-->
            </div>
    </section>

    </div>
</template>

<script>
    export default {
        name: 'SourceIntegrations',
        props: {

            plugins: {
                type: Array,
                default() {
                    return [
                        {name: 'ActiveMq'},
                        {name: 'Azure Event Hubs'},
                        {name: 'CloudWatch'},
                        {name: 'CouchDB'},
                        {name: 'Elastic Search'},
                        {name: 'Google Cloud Storage'},
                        {name: 'Google Pubsub'},
                        {name: 'Graphite'},
                        {name: 'Http'},
                        {name: 'Kafka'},
                        {name: 'Kinesis'},
                        {name: 'MySQL'},
                        {name: 'Postgres'},
                        {name: 'S3'},
                        {name: 'SQS'},
                        {name: 'TCP'},
                        {name: 'Twitter'},
                        {name: 'Salesforce'},
                    ];
                },
            },

        },
        methods: {
            clickEvent(name) {
              this.$gtag.event('click', {
                event_category: 'data_sources',
                event_label: name,
              })
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
